import { render, staticRenderFns } from "./PanelistAlternativePage.vue?vue&type=template&id=2caccc0c"
import script from "./PanelistAlternativePage.vue?vue&type=script&lang=ts"
export * from "./PanelistAlternativePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports